import React from 'react';
import { Switch, Route, RouteComponentProps } from 'react-router-dom';

import { GuestSurveyPage } from './pages';

export const GuestSurveyRoutes: React.FC<RouteComponentProps> = ({ match }) => (
  /*
  Originally I was going to use this, but I may remove and just keep the routing logic in app.routes.tsx.
  */
  <Switch>
    <Route path={`${match.path}/:propertyId/:userId/:reservationId/`} component={GuestSurveyPage} />
  </Switch>
);
